import {Box, Typography} from "@mui/material";
import React, {useEffect, useRef} from "react";
import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";

import BackNextNavigation from "./BackNextNavigation";
import {makeStyles} from "tss-react/mui";

const StartScanInstructionPage = ( { handleNext, handlePrevious = undefined } ) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ScanInstructions");
    const startHeader = t("startHeader");
    const startInstruction = t("startInstruction");

    const {classes} = MaskSelectorToolStyles();

    const ScanInstructionsStyles = makeStyles()(() => ({
        header: {
            fontSize: 17,
            fontWeight: 600
        },
        instruction: {
            fontSize: 16,
            fontWeight: 400
        }
    }));

    const {classes: scanInstructionsClasses} = ScanInstructionsStyles();

    const headingRef = useRef(null);

    useEffect(() => {
        if(headingRef?.current) {
            headingRef.current.focus();
        }
    });

    const buttonNavigationHeight = "70px";

    return(
        <>
            <Box sx={{height: "100%"}} className={ `${classes.mainBox} ${classes.instructionMainBox}` }>
                <Box sx={{height: `calc(100% - ${buttonNavigationHeight})`}}>
                    <Box paddingY="24px" minHeight="204px">
                        <Box>
                            <Typography className={`${scanInstructionsClasses.header} ${classes.noOutline}`} tabIndex="0" aria-label={startHeader} ref={headingRef}>{startHeader}</Typography>
                        </Box>
                        <Box className = {classes.centeredBox} minHeight="120px">
                            <Typography className={`${scanInstructionsClasses.instruction} ${classes.noOutline}`} tabIndex="0" aria-label= {startInstruction}>
                                {startInstruction}
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={ `${classes.instructionBox} ${classes.centeredBox}` }></Box>
                </Box>
            </Box>
            <Box className={`${classes.buttonBox}`}>
                <BackNextNavigation handleNext={handleNext} handlePrevious={handlePrevious} />
            </Box>
        </>
    )

}

export default StartScanInstructionPage
